import React, { ChangeEvent, FC } from 'react';
import { POLICY_SELECT_ACCOUNT_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { Tooltip } from '@material-ui/core';

export interface IncludingUsersCheckboxesProps {
    accountTypes?: string[];
    withLocalAccounts?: boolean;
    includeAllLocalAccounts?: boolean;
    onIncludeAccountTypeChanged: (event: ChangeEvent<HTMLInputElement>, accountType: string) => void;
    onIncludeAllLocalAccountsChanged?: (includeAllLocalAccounts: boolean) => void;
}

const IncludingUsersCheckboxes: FC<IncludingUsersCheckboxesProps> = ({
    accountTypes = [],
    withLocalAccounts = false,
    includeAllLocalAccounts,
    onIncludeAccountTypeChanged,
    onIncludeAllLocalAccountsChanged
}) => {
    return (
        <div className="flex flex-col gap-[10px] pb-[15px] items-start">
            <span className="text-16 font-semibold leading-[24px]">INCLUDE</span>
            <div className="flex items-start self-start gap-4">
                {withLocalAccounts && (
                    <div className="sfcheckbox">
                        <input
                            id="confirmationCheckbox-local"
                            type="checkbox"
                            name="confirmationCheckbox"
                            checked={includeAllLocalAccounts}
                            onChange={(event) => onIncludeAllLocalAccountsChanged?.(event.target.checked)}
                        />
                        <label className="checkboxLabel" htmlFor="confirmationCheckbox-local">
                            All local accounts
                        </label>
                    </div>
                )}
                <div className="flex gap-[5px] items-center">
                    <div className="sfcheckbox">
                        <input
                            id="confirmationCheckbox-machineAccounts"
                            type="checkbox"
                            name="confirmationCheckbox"
                            checked={accountTypes.includes(POLICY_SELECT_ACCOUNT_OPTIONS.MACHINE_ACCOUNTS)}
                            onChange={(event) =>
                                onIncludeAccountTypeChanged(event, POLICY_SELECT_ACCOUNT_OPTIONS.MACHINE_ACCOUNTS)
                            }
                        />
                        <label
                            className="checkboxLabel mb-0 flex items-center"
                            htmlFor="confirmationCheckbox-machineAccounts">
                            Machine accounts
                        </label>
                    </div>
                    <Tooltip
                        title={
                            <div className="font-normal">
                                {`Apply this policy to any machine accounts in the groups you chose. Note! For an `}
                                <span className="font-bold">MFA</span>
                                {` policy, you must select an `}
                                <span className="font-bold">Unpaired Users Action</span>
                                {` (under `}
                                <span className="font-bold">Advanced Options</span>
                                {`) to avoid unintentionally blocking machine accounts.`}
                            </div>
                        }
                        arrow={true}
                        classes={{ tooltip: 'generic-tooltip' }}
                        placement="right">
                        <div className="moreInfoIcon" />
                    </Tooltip>
                </div>
                <div className="sfcheckbox">
                    <input
                        id="confirmationCheckbox-unresolved"
                        type="checkbox"
                        name="confirmationCheckbox"
                        checked={accountTypes.includes(POLICY_SELECT_ACCOUNT_OPTIONS.UNRESOLVED)}
                        onChange={(event) =>
                            onIncludeAccountTypeChanged(event, POLICY_SELECT_ACCOUNT_OPTIONS.UNRESOLVED)
                        }
                    />
                    <label className="checkboxLabel" htmlFor="confirmationCheckbox-unresolved">
                        Unresolved accounts
                    </label>
                </div>
            </div>
        </div>
    );
};

export default IncludingUsersCheckboxes;
